var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification__wrapper" },
    _vm._l(_vm.notifications, function (notification) {
      return _c(
        "div",
        {
          class:
            "alert alert-dismissible fade show alert-" + notification.context,
          attrs: { role: "alert" },
        },
        [
          notification.context === "danger"
            ? _c("div", { staticClass: "notification__title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$translate("ODNaPo::NaPo.error")) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          notification.context === "success"
            ? _c("div", { staticClass: "notification__title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$translate("ODNaPo::NaPo.success")) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn__icon btn__icon--close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return notification.close()
                },
              },
            },
            [
              _c("svg", { attrs: { width: "14", height: "14" } }, [
                _c("use", {
                  attrs: {
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "xlink:href": "#svg-close",
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "notification__msg" },
            [
              _vm.showErrorCode
                ? _c("span", [
                    _vm._v(
                      "\n                Code: " +
                        _vm._s(notification.code) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                domProps: { innerHTML: _vm._s(notification.message) },
              }),
              _vm._v(" "),
              _vm._l(notification.stackTrace, function (trace) {
                return _c("p", { staticClass: "notification__trace" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(trace.message) +
                      "\n            "
                  ),
                ])
              }),
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }